import React, { Component } from 'react';
import {
    Container,
    Col,
    Row,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import { HomeButtonCat } from './HomeButtonCat'
import iconaBlank from '../../img/icona blank.png'
/**
 * Used for the Listino Prezzi section. 
 */
export class Catalogo extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            //Level 2 dropdown open or closed
            dropdownOpen: false,
            //Visibility of Level 1
            showdropdown: false,
        };

    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }
        render() {

            //Creates the Level 1 Buttons with the appropriate highlighting
            const livelli1Buttons = (
                <Row style={{ width: '100%', margin: '0px' }}>
                    {this.props.livelli1.map(value => {
                        let bgColor = '';

                        //Sets the background color of the button
                        if (this.props.livelli1Id !== 0 && value.livelli1Id === this.props.livelli1Id) {
                            bgColor = '#57d2ff';
                        }
                        else {
                            bgColor = 'transparent';
                        }

                        //Returns a button with the specified image and text for Level 1
                        return <HomeButtonCat buttonBackground={bgColor}
                            clicked={() => this.props.handleLivelli1ButtonClick(value.livelli1Id, value.deslv1)}
                            image={iconaBlank} //TODO: Create function to determine appropriate image
                            key={value.livelli1Id}
                            id={value.livelli1Id}
                            name={value.deslv1}
                            needsText={true} //will remove once there is images
                            off="true"
                            classes={"col-md-3 col-6"} />
                    })}
                </Row>
            );

            //Creates the Level 2 Dropdown menu
            const livelli2DropDown = (
                <Container>
                    <Row>
                        <Col className="my-auto" style={{ width: '100%', textAlign: 'center' }}>
                            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                                <DropdownToggle caret>
                                    {this.props.livelli2Val}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem
                                        onClick={() => this.props.handleLivelli2SelectAll("VISUALIZZA TUTTI")}>
                                        VISUALIZZA TUTTI
                                </DropdownItem>
                                    {   //Creates an item in the dropdown list for each item from the call to the server
                                        this.props.livelli2.map(value =>
                                            <DropdownItem
                                                key={value.livelli2Id}
                                                onClick={() => this.props.handleLivelli2Selected(value.livelli2Id, value.deslv2)}>
                                                {value.deslv2}
                                            </DropdownItem>)
                                    }
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                    </Row>
                </Container>
            );

            return (
                <Container fluid>
                    {this.props.showLivelli2 ? livelli2DropDown : null}
                    {this.props.showLivelli1 ? livelli1Buttons : null}
                </Container>

            )
        }
   
}


// WEBPACK FOOTER //
// ./src/components/Catalogo/Catalogo.js